import React from 'react'
import NFTMarketPlaceMenu from '../../components/NFTMarketPlaceMenu'

import { PageWrapper } from './styled'
import { NFTStakeList } from '../../data/NFTStakeList'
import { INFTStakeList } from '../../models/INFTStake'
import NFTStakeCard from './StakeCard'
import Scrollbar from '../../components/Scrollbar'

export default function NFTStake() {
  return (
    <PageWrapper>
      <Scrollbar>
        <div className={`stakeList ${NFTStakeList.length === 1 ? 'oneStake' : ''}`}>
          {NFTStakeList.map((item: INFTStakeList) => (
            <NFTStakeCard key={`${item.collection.id}_NFT_STAKE_CARD`} data={item} />
          ))}
        </div>
      </Scrollbar>
    </PageWrapper>
  )
}
